"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DropdownMenu_scss_1 = __importDefault(require("./DropdownMenu.scss"));
const DropdownMenuItem_1 = __importDefault(require("./DropdownMenuItem"));
function DropdownMenuItems({ items, closeMenu }) {
    return (react_1.default.createElement("div", { className: DropdownMenu_scss_1.default.container },
        react_1.default.createElement("div", { className: DropdownMenu_scss_1.default.spacer }),
        items.map((item) => (react_1.default.createElement(DropdownMenuItem_1.default, { item: item, key: item.title, closeMenu: closeMenu }))),
        react_1.default.createElement("div", { className: DropdownMenu_scss_1.default.spacer })));
}
exports.default = DropdownMenuItems;
